const apis = {
  getUserInfo: '/api/partner/padmin/org/r/my-info',
  getMenuList: '/api/partner/padmin/org/r/query-user-menu',
  getUserPartnerInfo: '/api/partner/padmin/org/r/myPartnerInfo',
  getUserPermissions: '/api/partner/padmin/org/r/query-user-api',
  getUserRegions: '/api/partner/padmin/org/r/query-user-region',
  getReminders: '/api/partner/padmin/r/reminders',
  queryUserRole: '/api/partner/padmin/org/r/query-user-role',
  aiChatAuth: '/api/partner/padmin/r/checkHasLLMAuth',
  targetRemind: '/api/evaluation/partner/target/r/targetRemind', // 巴西商考核全局弹窗接口
  performanceReport: '/api/aigc/performance/report',
  confirmWarningPlanRecord: '/api/partner/padmin/warning/w/confirmWarningPlanRecord'
}

export default apis
